import type { PoiCategory } from '$lib/components/pois/types';
import type { AdFormat } from '../constants';

export const ITALIA_CLIENT_ID = '5180,2787961';

// To build a ad unit, we need to get a position that depends on the ad format
// These prefixes are set by the ad server
export const italiaFormatPositionMapping: Record<AdFormat, string> = {
	'1x1': 'bottom',
	'320x100': 'top',
	'300x250': 'top',
	'300x600': 'bottom',
	'728x90': 'bottom',
	'1000x90': 'bottom',
};

export const poiListItaliaPageIdByCategory: Record<PoiCategory, string> = {
	ACCOMMODATION: 'alberghi',
	EV_SERVICE: 'ev_station',
	PARKING: 'parking',
	RESTAURANT: 'ristoranti',
	REST_STOP: 'rest.stop',
	SERVICE_GAS_STATION: 'service.gas.station',
	TOURISM: 'siti_turistici',
	PARTNER: 'partner',
	PARTNER2: 'partner2',
};
